import React, { useState } from 'react';
import { Box, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export default function QualificationItem({ qualification, index, onChange, onRemove, showValidation }) {
  const [openDialog, setOpenDialog] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // 親コンポーネントに変更を伝える際にresetValidationパラメータを渡す
    onChange(index, { ...qualification, [name]: value }, { resetValidation: true });
  };

  const handleDelete = () => {
    // 資格名か取得日が入力されている場合は削除確認ダイアログを表示
    const hasQualificationInput = (qualification.name && qualification.name.trim() !== '') ||
                    (qualification.acquisition_date && qualification.acquisition_date.trim() !== '');

    if (hasQualificationInput) {
      setOpenDialog(true);
    } else {
      onRemove(index);
    }
  };

  const handleConfirmDelete = () => {
    setOpenDialog(false);
    onRemove(index);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  // 資格名のバリデーションエラー（保存時のみ表示）
  const nameError = showValidation && (!qualification.name || qualification.name.trim() === '');
  // 取得日のバリデーションエラー（保存時のみ表示）
  const dateError = showValidation && (!qualification.acquisition_date || qualification.acquisition_date.trim() === '');

  // acquisition_dateの値から表示用の値を抽出（YYYY-MM形式に変換）
  const displayDate = qualification.acquisition_date
    ? qualification.acquisition_date.substring(0, 7)
    : '';

  return (
    <Box sx={{
      display: 'flex',
      mb: 2,
      gap: 2,
      alignItems: 'flex-start',
      flexDirection: { xs: 'column', sm: 'row' },
      '& > *': {
        width: { xs: '100%', sm: 'auto' }
      }
    }}>
      <TextField
        fullWidth
        id={`qualification-name-${index}`}
        name="name"
        label="資格名"
        value={qualification.name || ''}
        onChange={handleChange}
        placeholder="資格名"
        variant="outlined"
        size="small"
        required={true}
        error={nameError}
        sx={{ flex: { sm: '1 1 70%' } }}
      />

      <Box sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        width: { xs: '100%', sm: 'auto' },
        flex: { sm: '1 1 30%' }
      }}>
        <TextField
          id={`qualification-date-${index}`}
          name="acquisition_date"
          label="取得日"
          type="month"
          value={displayDate}
          onChange={(e) => {
            // 月の値を取得し、YYYY-MM-DD形式に変換
            const monthValue = e.target.value;
            const dateValue = monthValue ? `${monthValue}-01` : '';

            // 親コンポーネントに変更を伝える際にresetValidationパラメータを渡す
            onChange(index, { ...qualification, acquisition_date: dateValue }, { resetValidation: true });
          }}
          variant="outlined"
          size="small"
          required={true}
          error={dateError}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            max: new Date().toISOString().split('T')[0].substring(0, 7),
          }}
          fullWidth
        />

        <IconButton
          color="error"
          onClick={handleDelete}
          sx={{ p: 1 }}
        >
          <DeleteIcon />
        </IconButton>
      </Box>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle id="alert-dialog-title">
          資格削除の確認
        </DialogTitle>
        <DialogContent>
          この資格を削除してもよろしいですか？
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            キャンセル
          </Button>
          <Button onClick={handleConfirmDelete} color="error" autoFocus>
            削除
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
